// extracted by mini-css-extract-plugin
export default {"modal":"Modal_modal__57jNV","closeButton":"Modal_closeButton__BIScZ","closeButtonText":"Modal_closeButtonText__IzQir"};